import React from 'react'
import { compose, withProps } from 'recompose'
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps'

import CompanyInfo from 'data/company-info'
import defaultMapStyles from 'map-styles/default'
import cobhamMapStyles from 'map-styles/map-cobham-legacy'

const google_maps_api_key = "AIzaSyDYmPHZD942Ac6AnLqnEo_uCjFBiYikino"

import defaultMarker from '../static/img/map/marker-cobham.png'

const defaultMapOptions = {
  defaultZoom: 8,
  defaultCenter: { lat: CompanyInfo.lat, lng: CompanyInfo.lng },
  defaultOptions: {
    disableDefaultUI: false,
    draggable: true,
    fullscreenControl: false,
    mapTypeControl: false,
    scrollwheel: false
  },
  isMarkerShown: false,
  markerPosition: { lat: CompanyInfo.lat, lng: CompanyInfo.lng },
  markerIcon: defaultMarker,
  mapTypeId: "roadmap"
}

const Map = compose(
  withProps({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${google_maps_api_key}&v=3.exp&libraries=geometry,drawing,places`,
    loadingElement: <div style={{ height: `100%` }} />,
  containerElement: <div className={`content__map`} style={{ height: `100%`, width: `100%`, position: `absolute`, left: `0`, right: `0`, bottom: `0`, top: `0` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap
)(({...props}) => {
  const mapOptions = props.options ? { ...defaultMapOptions, ...props.options } : defaultMapOptions

  // deep merge of objects using spread operators isn't part of es6 spec, so we just do the same as above as we only have one nested object.
  mapOptions.defaultOptions = props.options.defaultOptions ? { ...defaultMapOptions.defaultOptions, ...props.options.defaultOptions } : defaultMapOptions.defaultOptions

  return (
    <GoogleMap {...mapOptions}>
      {mapOptions.isMarkerShown && <Marker position={mapOptions.markerPosition} icon={mapOptions.markerIcon} />}
    </GoogleMap>
  )
})

export default Map;



// WEBPACK FOOTER //
// /Users/terrymasher/Development/glenbeigh-ltd/src/components/Map.js